/**
 * Utility function to handle file downloads
 * @param {Blob} blob - The blob data to download
 * @param {string} filename - The filename for the downloaded file
 */
export const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Utility function to create Excel blob
 * @param {Blob} data - The response data
 * @returns {Blob} - Excel formatted blob
 */
export const createExcelBlob = (data) => {
  return new Blob([data], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
};
